import { render } from "./toolsView.vue?vue&type=template&id=3dca2ec8"
import script from "./toolsView.vue?vue&type=script&lang=js"
export * from "./toolsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__